/**
 * Country code to phone dial code mapping
 * Maps ISO country codes (e.g., "LT", "IT") to international dial codes (e.g., "+370", "+39")
 */
export const countryCodes: Record<string, string> = {
  AF: "+93",   // Afghanistan
  AL: "+355",  // Albania
  DZ: "+213",  // Algeria
  AS: "+1684", // American Samoa
  AD: "+376",  // Andorra
  AO: "+244",  // Angola
  AI: "+1264", // Anguilla
  AQ: "+672",  // Antarctica
  AG: "+1268", // Antigua and Barbuda
  AR: "+54",   // Argentina
  AM: "+374",  // Armenia
  AW: "+297",  // Aruba
  AU: "+61",   // Australia
  AT: "+43",   // Austria
  AZ: "+994",  // Azerbaijan
  BS: "+1242", // Bahamas
  BH: "+973",  // Bahrain
  BD: "+880",  // Bangladesh
  BB: "+1246", // Barbados
  BY: "+375",  // Belarus
  BE: "+32",   // Belgium
  BZ: "+501",  // Belize
  BJ: "+229",  // Benin
  BM: "+1441", // Bermuda
  BT: "+975",  // Bhutan
  BO: "+591",  // Bolivia
  BQ: "+599",  // Bonaire, Sint Eustatius and Saba
  BA: "+387",  // Bosnia and Herzegovina
  BW: "+267",  // Botswana
  BV: "+47",   // Bouvet Island (shared with Norway)
  BR: "+55",   // Brazil
  IO: "+246",  // British Indian Ocean Territory
  BN: "+673",  // Brunei
  BG: "+359",  // Bulgaria
  BF: "+226",  // Burkina Faso
  BI: "+257",  // Burundi
  KH: "+855",  // Cambodia
  CM: "+237",  // Cameroon
  CA: "+1",    // Canada (shared with US territories)
  CV: "+238",  // Cape Verde
  KY: "+1345", // Cayman Islands
  CF: "+236",  // Central African Republic
  TD: "+235",  // Chad
  CL: "+56",   // Chile
  CN: "+86",   // China
  CX: "+61",   // Christmas Island
  CC: "+61",   // Cocos (Keeling) Islands
  CO: "+57",   // Colombia
  KM: "+269",  // Comoros
  CG: "+242",  // Congo (Brazzaville)
  CD: "+243",  // Congo (Kinshasa)
  CK: "+682",  // Cook Islands
  CR: "+506",  // Costa Rica
  HR: "+385",  // Croatia
  CU: "+53",   // Cuba
  CW: "+599",  // Curaçao
  CY: "+357",  // Cyprus
  CZ: "+420",  // Czech Republic
  DK: "+45",   // Denmark
  DJ: "+253",  // Djibouti
  DM: "+1767", // Dominica
  DO: "+1",    // Dominican Republic (shared NANP)
  EC: "+593",  // Ecuador
  EG: "+20",   // Egypt
  SV: "+503",  // El Salvador
  GQ: "+240",  // Equatorial Guinea
  ER: "+291",  // Eritrea
  EE: "+372",  // Estonia
  SZ: "+268",  // Eswatini
  ET: "+251",  // Ethiopia
  FK: "+500",  // Falkland Islands
  FO: "+298",  // Faroe Islands
  FJ: "+679",  // Fiji
  FI: "+358",  // Finland
  FR: "+33",   // France
  GF: "+594",  // French Guiana
  PF: "+689",  // French Polynesia
  TF: "+262",  // French Southern Territories
  GA: "+241",  // Gabon
  GM: "+220",  // Gambia
  GE: "+995",  // Georgia
  DE: "+49",   // Germany
  GH: "+233",  // Ghana
  GI: "+350",  // Gibraltar
  GR: "+30",   // Greece
  GL: "+299",  // Greenland
  GD: "+1473", // Grenada
  GP: "+590",  // Guadeloupe
  GU: "+1671", // Guam
  GT: "+502",  // Guatemala
  GG: "+44",   // Guernsey
  GN: "+224",  // Guinea
  GW: "+245",  // Guinea-Bissau
  GY: "+592",  // Guyana
  HT: "+509",  // Haiti
  HM: "+672",  // Heard Island and McDonald Islands
  HN: "+504",  // Honduras
  HK: "+852",  // Hong Kong
  HU: "+36",   // Hungary
  IS: "+354",  // Iceland
  IN: "+91",   // India
  ID: "+62",   // Indonesia
  IR: "+98",   // Iran
  IQ: "+964",  // Iraq
  IE: "+353",  // Ireland
  IM: "+44",   // Isle of Man
  IL: "+972",  // Israel
  IT: "+39",   // Italy
  CI: "+225",  // Côte d'Ivoire
  JM: "+1876", // Jamaica
  JP: "+81",   // Japan
  JE: "+44",   // Jersey
  JO: "+962",  // Jordan
  KZ: "+7",    // Kazakhstan (shared with Russia)
  KE: "+254",  // Kenya
  KI: "+686",  // Kiribati
  KP: "+850",  // North Korea
  KR: "+82",   // South Korea
  KW: "+965",  // Kuwait
  KG: "+996",  // Kyrgyzstan
  LA: "+856",  // Laos
  LV: "+371",  // Latvia
  LB: "+961",  // Lebanon
  LS: "+266",  // Lesotho
  LR: "+231",  // Liberia
  LY: "+218",  // Libya
  LI: "+423",  // Liechtenstein
  LT: "+370",  // Lithuania
  LU: "+352",  // Luxembourg
  MO: "+853",  // Macao
  MG: "+261",  // Madagascar
  MW: "+265",  // Malawi
  MY: "+60",   // Malaysia
  MV: "+960",  // Maldives
  ML: "+223",  // Mali
  MT: "+356",  // Malta
  MH: "+692",  // Marshall Islands
  MQ: "+596",  // Martinique
  MR: "+222",  // Mauritania
  MU: "+230",  // Mauritius
  YT: "+262",  // Mayotte
  MX: "+52",   // Mexico
  FM: "+691",  // Micronesia
  MD: "+373",  // Moldova
  MC: "+377",  // Monaco
  MN: "+976",  // Mongolia
  ME: "+382",  // Montenegro
  MS: "+1664", // Montserrat
  MA: "+212",  // Morocco
  MZ: "+258",  // Mozambique
  MM: "+95",   // Myanmar
  NA: "+264",  // Namibia
  NR: "+674",  // Nauru
  NP: "+977",  // Nepal
  NL: "+31",   // Netherlands
  NC: "+687",  // New Caledonia
  NZ: "+64",   // New Zealand
  NI: "+505",  // Nicaragua
  NE: "+227",  // Niger
  NG: "+234",  // Nigeria
  NU: "+683",  // Niue
  NF: "+672",  // Norfolk Island
  MK: "+389",  // North Macedonia
  MP: "+1670", // Northern Mariana Islands
  NO: "+47",   // Norway
  OM: "+968",  // Oman
  PK: "+92",   // Pakistan
  PW: "+680",  // Palau
  PS: "+970",  // Palestine
  PA: "+507",  // Panama
  PG: "+675",  // Papua New Guinea
  PY: "+595",  // Paraguay
  PE: "+51",   // Peru
  PH: "+63",   // Philippines
  PN: "+64",   // Pitcairn
  PL: "+48",   // Poland
  PT: "+351",  // Portugal
  PR: "+1",    // Puerto Rico (shared NANP)
  QA: "+974",  // Qatar
  RE: "+262",  // Réunion
  RO: "+40",   // Romania
  RU: "+7",    // Russia (shared with Kazakhstan)
  RW: "+250",  // Rwanda
  BL: "+590",  // Saint Barthélemy
  SH: "+290",  // Saint Helena
  KN: "+1869", // Saint Kitts and Nevis
  LC: "+1758", // Saint Lucia
  MF: "+590",  // Saint Martin (French)
  PM: "+508",  // Saint Pierre and Miquelon
  VC: "+1784", // Saint Vincent and the Grenadines
  WS: "+685",  // Samoa
  SM: "+378",  // San Marino
  ST: "+239",  // São Tomé and Príncipe
  SA: "+966",  // Saudi Arabia
  SN: "+221",  // Senegal
  RS: "+381",  // Serbia
  SC: "+248",  // Seychelles
  SL: "+232",  // Sierra Leone
  SG: "+65",   // Singapore
  SX: "+1721", // Sint Maarten (Dutch)
  SK: "+421",  // Slovakia
  SI: "+386",  // Slovenia
  SB: "+677",  // Solomon Islands
  SO: "+252",  // Somalia
  ZA: "+27",   // South Africa
  GS: "+500",  // South Georgia and the South Sandwich Islands
  SS: "+211",  // South Sudan
  ES: "+34",   // Spain
  LK: "+94",   // Sri Lanka
  SD: "+249",  // Sudan
  SR: "+597",  // Suriname
  SJ: "+47",   // Svalbard and Jan Mayen
  SE: "+46",   // Sweden
  CH: "+41",   // Switzerland
  SY: "+963",  // Syria
  TW: "+886",  // Taiwan
  TJ: "+992",  // Tajikistan
  TZ: "+255",  // Tanzania
  TH: "+66",   // Thailand
  TL: "+670",  // Timor-Leste
  TG: "+228",  // Togo
  TK: "+690",  // Tokelau
  TO: "+676",  // Tonga
  TT: "+1868", // Trinidad and Tobago
  TN: "+216",  // Tunisia
  TR: "+90",   // Turkey
  TM: "+993",  // Turkmenistan
  TC: "+1649", // Turks and Caicos Islands
  TV: "+688",  // Tuvalu
  UG: "+256",  // Uganda
  UA: "+380",  // Ukraine
  AE: "+971",  // United Arab Emirates
  GB: "+44",   // United Kingdom
  US: "+1",    // United States
  UM: "+1",    // United States Minor Outlying Islands (shared)
  UY: "+598",  // Uruguay
  UZ: "+998",  // Uzbekistan
  VU: "+678",  // Vanuatu
  VA: "+379",  // Vatican City (officially +39 shared with Italy, but +379 allocated)
  VE: "+58",   // Venezuela
  VN: "+84",   // Vietnam
  VG: "+1284", // Virgin Islands (British)
  VI: "+1340", // Virgin Islands (U.S.)
  WF: "+681",  // Wallis and Futuna
  EH: "+212",  // Western Sahara (shared with Morocco)
  YE: "+967",  // Yemen
  ZM: "+260",  // Zambia
  ZW: "+263",  // Zimbabwe
};

/**
 * Get country options for selects.
 *
 * Generates the full ISO list via Intl (includes all countries).
 * Note: assumes a modern environment (Intl.supportedValuesOf + Intl.DisplayNames).
 */
export const getAllCountryOptions = (t: (key: string) => string) => {
  void t;
  try {
    const locale =
      typeof navigator !== "undefined" && navigator.language
        ? navigator.language
        : "en";

    const displayNamesAvailable =
      typeof (Intl as any).DisplayNames === "function";
    const displayNames = displayNamesAvailable
      ? new (Intl as any).DisplayNames([locale], { type: "region" })
      : null;

    // Use our dial-code map as the source of truth for which ISO codes to offer.
    // This avoids relying on Intl.supportedValuesOf('region'), which is not available in all browsers.
    const isoCodes = Object.keys(countryCodes)
      .map((c) => c.toUpperCase())
      .filter((code) => /^[A-Z]{2}$/.test(code));

    const options = isoCodes
      .map((code) => ({
        value: code,
        label: displayNames?.of(code) || code,
      }))
      .sort((a, b) => a.label.localeCompare(b.label, locale));

    return options;
  } catch {
    return [];
  }
};

/**
 * Get country options for VAT selector: label is ISO code (e.g. "LT", "DE"), not country name.
 * Includes an empty-value option ("-") at the top.
 */
export const getAllCountryISOptions = (_t: (key: string) => string) => {
  void _t;
  try {
    const isoCodes = Object.keys(countryCodes)
      .map((c) => c.toUpperCase())
      .filter((code) => /^[A-Z]{2}$/.test(code));
    const countryOptions = isoCodes
      .map((code) => ({ value: code, label: code }))
      .sort((a, b) => a.value.localeCompare(b.value));
    return [{ value: "", label: "-" }, ...countryOptions];
  } catch {
    return [{ value: "", label: "-" }];
  }
};

/**
 * Get the translated country name from a country code
 * @param countryCode - Two-letter country code (e.g., "IT", "LT")
 * @param t - Translation function
 * @returns Translated country name or the original code if not found
 */
export const getCountryName = (
  countryCode: string | undefined | null,
  _t: (key: string) => string
): string => {
  if (!countryCode) return "";
  void _t;

  const code = countryCode.toUpperCase();
  try {
    const locale =
      typeof navigator !== "undefined" && navigator.language
        ? navigator.language
        : "en";
    const displayNamesAvailable = typeof (Intl as any).DisplayNames === "function";
    if (!displayNamesAvailable) return code;

    const displayNames = new (Intl as any).DisplayNames([locale], { type: "region" });
    return displayNames.of(code) || code;
  } catch {
    return code;
  }
};
